import Backbone from 'backbone'
import KeySet from './key-set'

var KeySets = Backbone.Collection.extend({

	model: KeySet

})

export default KeySets

KeySets.__filename__ = 'admin/datasets/key-sets.js'
